import script from "./PressPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PressPage.vue?vue&type=script&setup=true&lang=js"

import "./PressPage.vue?vue&type=style&index=0&id=27479306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27479306"]])

export default __exports__